import React from "react";
import PropTypes from "prop-types";

import RadioChip from "../../../components/RadioChip";

const discountCodeTypes = [
    {
        value: "coupon",
        name: "Coupon",
        icon: "fa-solid fa-ticket-alt",
        description: "Een coupon heeft een vast bedrag dat over meerdere bestellingen besteed kan worden totdat de waarde op is.",
        disabled: true,
    },
    {
        value: "voucher",
        name: "Voucher",
        icon: "fa-solid fa-gift",
        description: "Een voucher is eenmalig te gebruiken voor een enkele bestelling en geeft een korting van een vast bedrag of percentage.",
        disabled: true,
    },
    {
        value: "promocode",
        name: "Promocode",
        icon: "fa-solid fa-percent",
        description: "Een promocode kan door meerdere klanten over meerdere bestellingen gebruikt worden om korting te ontvangen.",
        disabled: false,
    },
];

function DiscountCodeTypePicker({ discountCodeType, setDiscountCodeType }) {
    return (
        <React.Fragment>
            <div className="d-md-none">
                { discountCodeTypes.map((type) => (
                    <RadioChip
                        key={ type.value }
                        checked={ discountCodeType === type.value }
                        onClick={ type.disabled ? undefined : () => setDiscountCodeType(type.value) }
                        className={ "mr-2 mt-2" + (type.disabled ? " disabled" : "") }
                        disabled={ type.disabled }
                    >
                        <i className={ `${type.icon} mr-2` }/>
                        { type.name }
                    </RadioChip>
                ))}
            </div>
            <div className="d-none d-md-block">
                <div className="row">
                    { discountCodeTypes.map((type) => (
                        <div
                            className="col-md-4"
                            key={ type.value }
                        >
                            <div
                                className={ "card mt-2" + (type.disabled ? " disabled" : " pointer-cursor") + (discountCodeType === type.value ? " active" : "") }
                                onClick={ type.disabled ? undefined : () => setDiscountCodeType(type.value) }
                                onKeyDown={ type.disabled ? undefined : (event) => {
                                    if(event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        setDiscountCodeType(type.value);
                                    }
                                }}
                                style={ type.disabled ? { opacity: 0.5 } : undefined }
                                role="button"
                                tabIndex={ type.disabled ? -1 : 0 }
                                aria-pressed={ discountCodeType === type.value }
                                aria-disabled={ type.disabled }
                            >
                                <div className="card-body">
                                    <div style={{ fontSize: "1.5rem" }}>
                                        <i className={ type.icon }/>
                                    </div>
                                    <div className="mt-1">
                                        <strong>{ type.name }</strong>
                                    </div>
                                    <small className="text-muted">
                                        { type.description }
                                    </small>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    );
}
DiscountCodeTypePicker.propTypes = {
    discountCodeType: PropTypes.string,
    setDiscountCodeType: PropTypes.func.isRequired
};

export default React.memo(DiscountCodeTypePicker);
